jQuery(document).ready(function($) {
    $('.play-video').on('click', function(e) {
        e.preventDefault();
        $(this).closest('.ac-video').find('.video-modal').fadeIn();
    });
    $('.close-video').on('click', function(e) {
        e.preventDefault();
        $(this).closest('.video-modal').fadeOut();
        var video = $(this).closest(".video-modal").find("iframe");
        var video_url = video.attr("src");
        $(video).attr("src", "");
        $(video).attr("src", video_url);
    });
});